import {listenToHideToast} from "./blade-toast.js";
import {gtagApplyClicked} from "../helpers/GoogleAnalytics.js";
import {showModalConfirm} from "./modal-confirm";
import "./google-maps.js";
import "./copy-link.js";
import "./expandable-descriptions.js";
import {ENV_DEMO} from "../constants/EnvironmentType";

const applyNowButtons = document.getElementsByClassName("apply-now-btn");
const createAccountBtns = document.getElementsByClassName("create-account-btn");
const appliedBtn = document.getElementById("appliedBtn");
const userFirstNameEls = document.getElementsByClassName("user-first-name");
let gtagApplyClickHandled = false;

const openModal = (modalId) => {
  const modal = document.getElementById(modalId);

  if (!modal) {
    if (import.meta.env.VITE_ENV === ENV_DEMO) return toast.error("This feature is disabled in demo mode.");
    throw new Error(`Modal with id ${modalId} not found`);
  }

  document.body.style.overflow = "hidden";
  if (!modal.classList.contains("hidden")) return;

  if (!gtagApplyClickHandled) {
    gtagApplyClicked(window.location.pathname.split("/")[2]);
    gtagApplyClickHandled = true;
  }

  modal.setAttribute("aria-expanded", "true");

  modal.classList.add("opacity-0");
  modal.classList.remove("hidden");
  setTimeout(() => modal.classList.remove("opacity-0"), 200);
};

const closeModal = (modalId) => {
  document.body.style.overflow = "";

  const modal = document.getElementById(modalId);

  if (!modal) {
    throw new Error(`Modal with id ${modalId} not found`);
  }

  modal.setAttribute("aria-expanded", "false");
  modal.classList.add("opacity-0");
  setTimeout(() => {
    modal.classList.add("hidden");
  }, 200);
};

const handleApplicationSubmitted = () => {
  closeModal("quickApplyModalBladeContainer");

  for (let i = 0; i < applyNowButtons.length; i++) {
    const btn = applyNowButtons[i];
    btn.classList.add("hidden");
  }

  if (appliedBtn) appliedBtn.classList.remove("hidden");
};

const openNewUserModal = () => {
  openModal("newUserModal");
};

const handleNewUserEvent = (e) => {
  for (let i = 0; i < userFirstNameEls.length; i++) {
    const el = userFirstNameEls[i];
    el.innerText = e?.detail?.firstName;
  }
  setTimeout(openNewUserModal, 200);
};

const listenToCloseModalEvents = () => {
  const modalCloseButtons = document.getElementsByClassName("modal-close-btn");

  for (let i = 0; i < modalCloseButtons.length; i++) {
    const btn = modalCloseButtons[i];
    const shouldConfirm = btn.dataset.confirm === "true";
    const title = btn.dataset.modalTitle || "Close Modal";
    const message = btn.dataset.modalDescription || "Are you sure you want to close this?";
    const foregroundHex = btn.dataset.modalForeground || "";
    const backgroundHex = btn.dataset.modalBackground || "";

    btn.addEventListener("click", () => {
      const modalId = btn.dataset.modalId;
      if (!modalId) throw new Error("Modal id not found");

      if (shouldConfirm) {
        showModalConfirm(
          title,
          message,
          () => closeModal(modalId),
          "Confirm & Close",
          "Nevermind",
          foregroundHex,
          backgroundHex
        );
      } else {
        closeModal(modalId);
      }
    });
  }

  const urlParams = new URLSearchParams(window.location.search);
  const shouldOpenModal = urlParams.get("apply") === "true" || urlParams.get("apply") === "1" || urlParams.get("invited") === "1";
  if (shouldOpenModal) openModal("quickApplyModalBladeContainer");

  document.addEventListener("bd-application-submitted", handleApplicationSubmitted);
  document.addEventListener("bd-created-user", handleNewUserEvent);
};

for (let i = 0; i < applyNowButtons.length; i++) {
  const btn = applyNowButtons[i];
  btn.addEventListener("click", () => openModal("quickApplyModalBladeContainer"));
}

const handleCreateAccountButton = () => {
  if (!createAccountBtns?.length) return;

  const canQuickApply = applyNowButtons.length > 0;

  for (let i = 0; i < createAccountBtns.length; i++) {
    const btn = createAccountBtns[i];
    if (canQuickApply) btn.addEventListener("click", () => openModal("quickApplyModalBladeContainer"));
    else btn.addEventListener("click", () => window.location.href = "/create-account");
  }
};

listenToCloseModalEvents();
listenToHideToast();
handleCreateAccountButton();

